// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact-Us Center (고객센터 / 정보 게시판) — UI shell styles.
   Uses global theme tokens from ~/css/variables.css (e.g. --primary-default #3054F1). */

.cuc-root {
  --cuc-primary: var(--primary-default, #3054F1);
  --cuc-primary-soft: var(--orange-trans-color, #fff7ed);
  --cuc-border: #e5e7eb;
  --cuc-text: #1f2937;
  --cuc-text-muted: #6b7280;

  max-width: 1120px;
  margin: 0 auto;
  padding: 24px 16px 64px;
  color: var(--cuc-text);
  font-family: inherit;
}

/* ---------- Main tabs (고객센터 / 정보 게시판) ---------- */
.cuc-main-tabs {
  display: flex;
  gap: 28px;
  border-bottom: 1px solid var(--cuc-border);
  padding: 0 8px;
  background: #fff;
  border-radius: 12px 12px 0 0;
}

.cuc-main-tab {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: var(--cuc-text-muted);
  padding: 18px 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 3px solid transparent;
  margin-bottom: -1px;
}

.cuc-main-tab.is-active {
  color: var(--cuc-primary);
  border-bottom-color: var(--cuc-primary);
}

/* ---------- Card / panel ---------- */
.cuc-panel {
  background: #fff;
  border: 1px solid var(--cuc-border);
  border-radius: 16px;
  padding: 28px;
  margin-top: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* ---------- Pill sub-tabs (공지사항 / FAQ / ...) ---------- */
.cuc-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
}

.cuc-pill {
  background: #fff;
  border: 1px solid var(--cuc-border);
  border-radius: 999px;
  padding: 9px 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--cuc-text);
  cursor: pointer;
  transition: all 0.15s ease;
}

.cuc-pill.is-active {
  background: var(--cuc-primary-soft);
  border-color: var(--cuc-primary);
  color: var(--cuc-primary);
}

/* ---------- Small chip filters (FAQ category) ---------- */
.cuc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.cuc-chip {
  background: #fff;
  border: 1px solid var(--cuc-border);
  border-radius: 999px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cuc-text);
  cursor: pointer;
}

.cuc-chip.is-active {
  background: #111827;
  border-color: #111827;
  color: #fff;
}

/* ---------- Info banner ---------- */
.cuc-info-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--cuc-primary-soft);
  border: 1px solid #ffe2c2;
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 14px;
  color: #7c4a13;
  margin-bottom: 20px;
}

.cuc-info-banner strong {
  color: var(--cuc-primary);
}

/* ---------- Tables ---------- */
.cuc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.cuc-table thead th {
  text-align: left;
  color: var(--cuc-text-muted);
  font-weight: 600;
  padding: 14px 12px;
  border-bottom: 1px solid var(--cuc-border);
}

.cuc-table tbody td {
  padding: 18px 12px;
  border-bottom: 1px solid #f1f3f5;
  vertical-align: middle;
}

.cuc-table tbody tr:hover {
  background: #fafafa;
}

.cuc-col-no {
  width: 110px;
  text-align: center;
  color: var(--cuc-text-muted);
}

.cuc-col-date {
  width: 140px;
  color: var(--cuc-text-muted);
}

.cuc-col-views {
  width: 80px;
  text-align: right;
  color: var(--cuc-text-muted);
}

.cuc-col-action {
  width: 100px;
  text-align: right;
}

.cuc-row-title {
  font-weight: 500;
  color: var(--cuc-text);
  cursor: pointer;
}

.cuc-row-title.is-pinned {
  font-weight: 700;
}

/* ---------- Pinned badge (고정) ---------- */
.cuc-pin-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--cuc-primary-soft);
  color: var(--cuc-primary);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

/* ---------- FAQ accordion ---------- */
.cuc-faq-item {
  border: 1px solid var(--cuc-border);
  border-radius: 12px;
  margin-top: 14px;
  overflow: hidden;
}

.cuc-faq-q,
.cuc-faq-a {
  display: flex;
  gap: 12px;
  padding: 18px 20px;
  font-size: 14px;
}

.cuc-faq-q {
  font-weight: 700;
  cursor: pointer;
  align-items: center;
}

.cuc-faq-a {
  background: #fafafa;
  border-top: 1px solid var(--cuc-border);
  color: #374151;
  line-height: 1.6;
}

/* Answer text + attachment downloads stacked in the content column (right of the "A" mark). */
.cuc-faq-a-col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cuc-faq-a-content {
  min-width: 0;
}

/* Tidy the rich-text (TinyMCE) answer markup. */
.cuc-faq-a-content > :first-child {
  margin-top: 0;
}

.cuc-faq-a-content > :last-child {
  margin-bottom: 0;
}

.cuc-faq-a-content img,
.cuc-faq-a-content video,
.cuc-faq-a-content iframe {
  max-width: 100%;
}

.cuc-qa-mark {
  width: 26px;
  height: 26px;
  flex: none;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
}

.cuc-qa-mark.q {
  background: var(--cuc-primary);
}

.cuc-qa-mark.a {
  background: #9ca3af;
}

/* ---------- Search row ---------- */
.cuc-search-row {
  display: flex;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 18px;
}

.cuc-search-row .p-inputtext {
  flex: 1;
  padding-left: 16px;
}

/* ---------- Forms (1:1 문의 / 수업 상담) ---------- */
.cuc-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.cuc-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.cuc-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cuc-field label {
  font-size: 14px;
  font-weight: 700;
}

/* Required-field marker. */
.cuc-required {
  color: var(--cuc-danger, #e11900);
  margin-left: 2px;
}

/* Inline validation error message under a field. */
.cuc-field-error {
  color: var(--cuc-danger, #e11900);
  font-size: 12px;
  font-weight: 400;
}

/* Error state for the consent row. */
.cuc-consent.cuc-consent-error {
  color: var(--cuc-danger, #e11900);
}

.cuc-field .p-inputtext,
.cuc-field .p-inputtextarea,
.cuc-field .p-dropdown {
  width: 100%;
}

.cuc-form-intro h3 {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
}

.cuc-form-intro p {
  margin: 0 0 8px;
  color: var(--cuc-text-muted);
  font-size: 14px;
}

.cuc-consent {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--cuc-text-muted);
}

/* Layout only — colour comes from the global keduall-buttons classes. */
.cuc-form-submit.p-button {
  align-self: flex-start;
}

/* Reduce the global pill radius on buttons within this page. */
.cuc-root .keduall-buttons {
  border-radius: 8px;
}

/* Match the search field corners to the buttons. */
.cuc-search-row .p-inputtext,
.cuc-board-toolbar .p-inputtext,
.cuc-board-toolbar .p-dropdown {
  border-radius: 8px;
}

/* ---------- Info-board card grid (수업현장) ---------- */
.cuc-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
}

.cuc-card {
  border: 1px solid var(--cuc-border);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
}

.cuc-card-thumb {
  position: relative;
  aspect-ratio: 16 / 10;
  background: #f3f4f6;
  overflow: hidden;
}

.cuc-card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cuc-card-pin {
  position: absolute;
  top: 10px;
  left: 10px;
}

.cuc-card-body {
  padding: 14px;
}

.cuc-card-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cuc-card-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--cuc-text-muted);
}

/* ---------- Board toolbar (search + total + view toggle) ---------- */
.cuc-board-toolbar {
  display: flex;
  align-items: stretch;
  gap: 10px;
  margin-bottom: 18px;
}

.cuc-board-toolbar .p-dropdown {
  width: 130px;
}

.cuc-board-toolbar .cuc-search-input {
  flex: 1;
  padding-left: 16px;
}

/* Count + view-toggle header row (전체 N건  ........  [목록][갤러리]) */
.cuc-board-count-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.cuc-board-count {
  font-size: 13px;
  color: var(--cuc-text-muted);
}

.cuc-board-count strong {
  color: var(--cuc-primary);
}

/* ---------- View toggle (목록 / 갤러리) ---------- */
.cuc-view-toggle {
  display: inline-flex;
  gap: 4px;
  flex: none;
}

.cuc-view-btn {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--cuc-border);
  border-radius: 8px;
  background: #fff;
  color: var(--cuc-text-muted);
  cursor: pointer;
  font-size: 15px;
  transition: all 0.15s ease;
}

.cuc-view-btn:hover {
  border-color: var(--cuc-primary);
  color: var(--cuc-primary);
}

.cuc-view-btn.is-active {
  background: var(--cuc-primary);
  border-color: var(--cuc-primary);
  color: #fff;
}

/* ---------- Simple paginator ---------- */
.cuc-paginator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 28px;
}

.cuc-page-btn {
  min-width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--cuc-border);
  background: #fff;
  cursor: pointer;
  font-weight: 600;
  color: var(--cuc-text);
}

.cuc-page-btn.is-active {
  background: var(--cuc-primary);
  border-color: var(--cuc-primary);
  color: #fff;
}

.cuc-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cuc-empty {
  text-align: center;
  color: var(--cuc-text-muted);
  padding: 40px 0;
}

.cuc-row-link {
  cursor: pointer;
}

.cuc-row-link:hover {
  text-decoration: underline;
  color: var(--cuc-primary);
}

.cuc-card-thumb-empty {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
}

/* ---------- Board post detail ---------- */
.cuc-detail {
  padding: 8px 4px;
}

.cuc-detail-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  color: #111827;
  margin: 0 0 14px;
  word-break: keep-all;
}

.cuc-detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  font-size: 13px;
  color: var(--cuc-text-muted);
  padding-bottom: 16px;
  border-bottom: 1px solid var(--cuc-border);
  margin-bottom: 24px;
}

.cuc-detail-body {
  font-size: 15px;
  line-height: 1.8;
  color: var(--cuc-text);
  min-height: 120px;
}

.cuc-detail-body img,
.cuc-detail-body video,
.cuc-detail-body iframe {
  max-width: 100%;
}

.cuc-detail-files {
  margin-top: 28px;
  border: 1px solid var(--cuc-border);
  border-radius: 12px;
  padding: 16px;
  background: #fafafa;
}

.cuc-detail-files-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.cuc-detail-files-title {
  font-weight: 700;
  font-size: 14px;
}

.cuc-detail-files ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cuc-detail-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--cuc-border);
  border-radius: 8px;
}

.cuc-detail-file-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--cuc-text);
  word-break: break-all;
}

.cuc-detail-file-icon {
  flex-shrink: 0;
  font-size: 15px;
  color: var(--cuc-text-muted);
}

.cuc-detail-download {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cuc-primary);
  background: none;
  border: none;
  cursor: pointer;
}

.cuc-detail-download:hover {
  text-decoration: underline;
}

.cuc-detail-download-all {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cuc-primary);
  background: none;
  border: none;
  cursor: pointer;
}

.cuc-detail-download-all:hover:not(:disabled) {
  text-decoration: underline;
}

.cuc-detail-download-all:disabled {
  opacity: 0.6;
  cursor: default;
}

/* Part 11 — prev / list / next footer navigation. */
.cuc-detail-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--cuc-border);
}

.cuc-detail-nav-side {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 500;
  color: var(--cuc-text-muted);
}

.cuc-detail-nav-side:hover:not(:disabled) {
  color: var(--cuc-primary);
}

.cuc-detail-nav-side:disabled {
  opacity: 0.4;
  cursor: default;
}

.cuc-detail-nav-list {
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background: #4b5563;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 10px 40px;
}

.cuc-detail-nav-list:hover {
  background: #374151;
}

@media (max-width: 640px) {
  .cuc-form-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/contact-us/ContactUsCenter.css"],"names":[],"mappings":"AAAA;wFACwF;;AAExF;EACE,8CAA8C;EAC9C,sDAAsD;EACtD,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;;EAEzB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,SAAS;EACT,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;AAClB;;AAEA,8FAA8F;AAC9F;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,iCAAiC;AACnC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;;;EAGE,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Contact-Us Center (고객센터 / 정보 게시판) — UI shell styles.\n   Uses global theme tokens from ~/css/variables.css (e.g. --primary-default #3054F1). */\n\n.cuc-root {\n  --cuc-primary: var(--primary-default, #3054F1);\n  --cuc-primary-soft: var(--orange-trans-color, #fff7ed);\n  --cuc-border: #e5e7eb;\n  --cuc-text: #1f2937;\n  --cuc-text-muted: #6b7280;\n\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 24px 16px 64px;\n  color: var(--cuc-text);\n  font-family: inherit;\n}\n\n/* ---------- Main tabs (고객센터 / 정보 게시판) ---------- */\n.cuc-main-tabs {\n  display: flex;\n  gap: 28px;\n  border-bottom: 1px solid var(--cuc-border);\n  padding: 0 8px;\n  background: #fff;\n  border-radius: 12px 12px 0 0;\n}\n\n.cuc-main-tab {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--cuc-text-muted);\n  padding: 18px 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -1px;\n}\n\n.cuc-main-tab.is-active {\n  color: var(--cuc-primary);\n  border-bottom-color: var(--cuc-primary);\n}\n\n/* ---------- Card / panel ---------- */\n.cuc-panel {\n  background: #fff;\n  border: 1px solid var(--cuc-border);\n  border-radius: 16px;\n  padding: 28px;\n  margin-top: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n/* ---------- Pill sub-tabs (공지사항 / FAQ / ...) ---------- */\n.cuc-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.cuc-pill {\n  background: #fff;\n  border: 1px solid var(--cuc-border);\n  border-radius: 999px;\n  padding: 9px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--cuc-text);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.cuc-pill.is-active {\n  background: var(--cuc-primary-soft);\n  border-color: var(--cuc-primary);\n  color: var(--cuc-primary);\n}\n\n/* ---------- Small chip filters (FAQ category) ---------- */\n.cuc-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.cuc-chip {\n  background: #fff;\n  border: 1px solid var(--cuc-border);\n  border-radius: 999px;\n  padding: 7px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--cuc-text);\n  cursor: pointer;\n}\n\n.cuc-chip.is-active {\n  background: #111827;\n  border-color: #111827;\n  color: #fff;\n}\n\n/* ---------- Info banner ---------- */\n.cuc-info-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--cuc-primary-soft);\n  border: 1px solid #ffe2c2;\n  border-radius: 10px;\n  padding: 14px 16px;\n  font-size: 14px;\n  color: #7c4a13;\n  margin-bottom: 20px;\n}\n\n.cuc-info-banner strong {\n  color: var(--cuc-primary);\n}\n\n/* ---------- Tables ---------- */\n.cuc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.cuc-table thead th {\n  text-align: left;\n  color: var(--cuc-text-muted);\n  font-weight: 600;\n  padding: 14px 12px;\n  border-bottom: 1px solid var(--cuc-border);\n}\n\n.cuc-table tbody td {\n  padding: 18px 12px;\n  border-bottom: 1px solid #f1f3f5;\n  vertical-align: middle;\n}\n\n.cuc-table tbody tr:hover {\n  background: #fafafa;\n}\n\n.cuc-col-no {\n  width: 110px;\n  text-align: center;\n  color: var(--cuc-text-muted);\n}\n\n.cuc-col-date {\n  width: 140px;\n  color: var(--cuc-text-muted);\n}\n\n.cuc-col-views {\n  width: 80px;\n  text-align: right;\n  color: var(--cuc-text-muted);\n}\n\n.cuc-col-action {\n  width: 100px;\n  text-align: right;\n}\n\n.cuc-row-title {\n  font-weight: 500;\n  color: var(--cuc-text);\n  cursor: pointer;\n}\n\n.cuc-row-title.is-pinned {\n  font-weight: 700;\n}\n\n/* ---------- Pinned badge (고정) ---------- */\n.cuc-pin-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: var(--cuc-primary-soft);\n  color: var(--cuc-primary);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* ---------- FAQ accordion ---------- */\n.cuc-faq-item {\n  border: 1px solid var(--cuc-border);\n  border-radius: 12px;\n  margin-top: 14px;\n  overflow: hidden;\n}\n\n.cuc-faq-q,\n.cuc-faq-a {\n  display: flex;\n  gap: 12px;\n  padding: 18px 20px;\n  font-size: 14px;\n}\n\n.cuc-faq-q {\n  font-weight: 700;\n  cursor: pointer;\n  align-items: center;\n}\n\n.cuc-faq-a {\n  background: #fafafa;\n  border-top: 1px solid var(--cuc-border);\n  color: #374151;\n  line-height: 1.6;\n}\n\n/* Answer text + attachment downloads stacked in the content column (right of the \"A\" mark). */\n.cuc-faq-a-col {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cuc-faq-a-content {\n  min-width: 0;\n}\n\n/* Tidy the rich-text (TinyMCE) answer markup. */\n.cuc-faq-a-content > :first-child {\n  margin-top: 0;\n}\n\n.cuc-faq-a-content > :last-child {\n  margin-bottom: 0;\n}\n\n.cuc-faq-a-content img,\n.cuc-faq-a-content video,\n.cuc-faq-a-content iframe {\n  max-width: 100%;\n}\n\n.cuc-qa-mark {\n  width: 26px;\n  height: 26px;\n  flex: none;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #fff;\n}\n\n.cuc-qa-mark.q {\n  background: var(--cuc-primary);\n}\n\n.cuc-qa-mark.a {\n  background: #9ca3af;\n}\n\n/* ---------- Search row ---------- */\n.cuc-search-row {\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.cuc-search-row .p-inputtext {\n  flex: 1;\n  padding-left: 16px;\n}\n\n/* ---------- Forms (1:1 문의 / 수업 상담) ---------- */\n.cuc-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.cuc-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n}\n\n.cuc-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cuc-field label {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n/* Required-field marker. */\n.cuc-required {\n  color: var(--cuc-danger, #e11900);\n  margin-left: 2px;\n}\n\n/* Inline validation error message under a field. */\n.cuc-field-error {\n  color: var(--cuc-danger, #e11900);\n  font-size: 12px;\n  font-weight: 400;\n}\n\n/* Error state for the consent row. */\n.cuc-consent.cuc-consent-error {\n  color: var(--cuc-danger, #e11900);\n}\n\n.cuc-field .p-inputtext,\n.cuc-field .p-inputtextarea,\n.cuc-field .p-dropdown {\n  width: 100%;\n}\n\n.cuc-form-intro h3 {\n  margin: 0 0 6px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.cuc-form-intro p {\n  margin: 0 0 8px;\n  color: var(--cuc-text-muted);\n  font-size: 14px;\n}\n\n.cuc-consent {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--cuc-text-muted);\n}\n\n/* Layout only — colour comes from the global keduall-buttons classes. */\n.cuc-form-submit.p-button {\n  align-self: flex-start;\n}\n\n/* Reduce the global pill radius on buttons within this page. */\n.cuc-root .keduall-buttons {\n  border-radius: 8px;\n}\n\n/* Match the search field corners to the buttons. */\n.cuc-search-row .p-inputtext,\n.cuc-board-toolbar .p-inputtext,\n.cuc-board-toolbar .p-dropdown {\n  border-radius: 8px;\n}\n\n/* ---------- Info-board card grid (수업현장) ---------- */\n.cuc-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 20px;\n}\n\n.cuc-card {\n  border: 1px solid var(--cuc-border);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  background: #fff;\n}\n\n.cuc-card-thumb {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  background: #f3f4f6;\n  overflow: hidden;\n}\n\n.cuc-card-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.cuc-card-pin {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n}\n\n.cuc-card-body {\n  padding: 14px;\n}\n\n.cuc-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  margin-bottom: 12px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.cuc-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--cuc-text-muted);\n}\n\n/* ---------- Board toolbar (search + total + view toggle) ---------- */\n.cuc-board-toolbar {\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.cuc-board-toolbar .p-dropdown {\n  width: 130px;\n}\n\n.cuc-board-toolbar .cuc-search-input {\n  flex: 1;\n  padding-left: 16px;\n}\n\n/* Count + view-toggle header row (전체 N건  ........  [목록][갤러리]) */\n.cuc-board-count-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.cuc-board-count {\n  font-size: 13px;\n  color: var(--cuc-text-muted);\n}\n\n.cuc-board-count strong {\n  color: var(--cuc-primary);\n}\n\n/* ---------- View toggle (목록 / 갤러리) ---------- */\n.cuc-view-toggle {\n  display: inline-flex;\n  gap: 4px;\n  flex: none;\n}\n\n.cuc-view-btn {\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--cuc-border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--cuc-text-muted);\n  cursor: pointer;\n  font-size: 15px;\n  transition: all 0.15s ease;\n}\n\n.cuc-view-btn:hover {\n  border-color: var(--cuc-primary);\n  color: var(--cuc-primary);\n}\n\n.cuc-view-btn.is-active {\n  background: var(--cuc-primary);\n  border-color: var(--cuc-primary);\n  color: #fff;\n}\n\n/* ---------- Simple paginator ---------- */\n.cuc-paginator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 28px;\n}\n\n.cuc-page-btn {\n  min-width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid var(--cuc-border);\n  background: #fff;\n  cursor: pointer;\n  font-weight: 600;\n  color: var(--cuc-text);\n}\n\n.cuc-page-btn.is-active {\n  background: var(--cuc-primary);\n  border-color: var(--cuc-primary);\n  color: #fff;\n}\n\n.cuc-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cuc-empty {\n  text-align: center;\n  color: var(--cuc-text-muted);\n  padding: 40px 0;\n}\n\n.cuc-row-link {\n  cursor: pointer;\n}\n\n.cuc-row-link:hover {\n  text-decoration: underline;\n  color: var(--cuc-primary);\n}\n\n.cuc-card-thumb-empty {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);\n}\n\n/* ---------- Board post detail ---------- */\n.cuc-detail {\n  padding: 8px 4px;\n}\n\n.cuc-detail-title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #111827;\n  margin: 0 0 14px;\n  word-break: keep-all;\n}\n\n.cuc-detail-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  font-size: 13px;\n  color: var(--cuc-text-muted);\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--cuc-border);\n  margin-bottom: 24px;\n}\n\n.cuc-detail-body {\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--cuc-text);\n  min-height: 120px;\n}\n\n.cuc-detail-body img,\n.cuc-detail-body video,\n.cuc-detail-body iframe {\n  max-width: 100%;\n}\n\n.cuc-detail-files {\n  margin-top: 28px;\n  border: 1px solid var(--cuc-border);\n  border-radius: 12px;\n  padding: 16px;\n  background: #fafafa;\n}\n\n.cuc-detail-files-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.cuc-detail-files-title {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.cuc-detail-files ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cuc-detail-file-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--cuc-border);\n  border-radius: 8px;\n}\n\n.cuc-detail-file-name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--cuc-text);\n  word-break: break-all;\n}\n\n.cuc-detail-file-icon {\n  flex-shrink: 0;\n  font-size: 15px;\n  color: var(--cuc-text-muted);\n}\n\n.cuc-detail-download {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--cuc-primary);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.cuc-detail-download:hover {\n  text-decoration: underline;\n}\n\n.cuc-detail-download-all {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--cuc-primary);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.cuc-detail-download-all:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.cuc-detail-download-all:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* Part 11 — prev / list / next footer navigation. */\n.cuc-detail-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--cuc-border);\n}\n\n.cuc-detail-nav-side {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px 4px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--cuc-text-muted);\n}\n\n.cuc-detail-nav-side:hover:not(:disabled) {\n  color: var(--cuc-primary);\n}\n\n.cuc-detail-nav-side:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.cuc-detail-nav-list {\n  cursor: pointer;\n  border: none;\n  border-radius: 8px;\n  background: #4b5563;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 10px 40px;\n}\n\n.cuc-detail-nav-list:hover {\n  background: #374151;\n}\n\n@media (max-width: 640px) {\n  .cuc-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
